import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Invalid credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-oc-beige flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white p-10 border border-oc-hairline">
        <Link to="/" className="wordmark text-lg">Operating<span className="accent">/</span>Class</Link>
        <div className="eyebrow text-oc-coral mt-6 mb-3">Editorial Console</div>
        <h1 className="font-editorial text-3xl text-oc-ink leading-tight mb-8">Sign in.</h1>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <label className="block">
            <span className="eyebrow text-oc-ink-muted mb-2 block">Email</span>
            <input
              data-testid="admin-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full h-12 px-4 bg-white border border-oc-hairline focus:border-oc-ink outline-none font-ui"
            />
          </label>
          <label className="block">
            <span className="eyebrow text-oc-ink-muted mb-2 block">Password</span>
            <input
              data-testid="admin-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full h-12 px-4 bg-white border border-oc-hairline focus:border-oc-ink outline-none font-ui"
            />
          </label>
          {error && <div data-testid="admin-error" className="font-ui text-sm text-oc-coral">{error}</div>}
          <button
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full h-12 bg-oc-blue text-white font-ui text-sm font-bold uppercase tracking-widest hover:bg-oc-blue-hover disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
